export const pingPeriod = 10000
export const fetchReferralsPeriod = 10000

export const notReadyTimer = 7000
export const startGameTimer = 2000

export const defaultGameDuration = 180000
export const gameDuration = new Map(
  [2, 3, 4, 5, 6, 7].map((n) => [n, defaultGameDuration + (n - 2) * 30_000])
)

export const defaultTurnDuration = 13000
export const turnDuration = new Map([
  [2, defaultTurnDuration],
  [3, 12500],
  [4, 12000],
  [5, 11500],
  [6, 11000],
  [7, 10000],
])
